import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useSetSentryIdentifier } from '@/hooks/useSetSentryIdentifier';
import i18n from '@/settings/i18n';
import Routes from '@/settings/Routes';
import { Scroller } from '@/components/utils/Scroller';
import { ZendeskWidget } from '@/components/shared/ZendeskWidget';
import { AppHeaderContainer } from '@/components/shared/AppHeader';
import { AppFooter } from '@/components/shared/AppFooter';
import { FlashMessageContainer } from '@/components/shared/FlashMessage';
import { noticeStore } from '@/store/notice';
import { useAppDispatch } from '@/store';

export const App: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  useSetSentryIdentifier();

  useEffect(() => {
    dispatch(noticeStore.asyncActions.fetchNotices());
  }, [dispatch]);

  return (
    <Scroller>
      <Wrapper>
        <Helmet htmlAttributes={{ lang: i18n.languages[0] }}>
          <title>{t('pages.top.title')}</title>
        </Helmet>
        <FlashMessageContainer />
        <AppHeaderContainer />
        {Routes}

        <AppFooter />
        <ZendeskWidget />
      </Wrapper>
    </Scroller>
  );
};

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  min-height: 100vh;
  flex-direction: column;
  justify-content: space-between;
  color: rgba(0, 0, 0, 0.82);
`;
